<script lang="ts" setup>
const props = defineProps({
  linkTitle: String,
  icon: {
    type: String,
    default: 'icon-plus'
  }
})
</script>

<template>
  <button class="button">
    <div class="button__icon">
      <svg-icon :name="props.icon" />
    </div>
    <div class="button__title" v-if="props.linkTitle">{{ props.linkTitle }}</div>
  </button>
</template>

<style lang="scss" scoped>
.button {
  display: flex;
  align-items: center;
  padding: toRem(12) 0;
  background: none;
  font-size: toRem(16);
  font-weight: 400;
  line-height: 1.45;
  color: $color-gray-1;
  border-radius: toRem(50);
  border: none;
  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: toRem(40);
    height: toRem(40);
    margin-right: toRem(10);
    border: 1px solid $color-gray-line;
    border-radius: 50%;
    color: $color-brand-3;
    svg {
      width: toRem(20);
      height: toRem(20);
    }
  }
}
</style>
